export default "__VITE_ASSET__ieP85nmV__";